export const iconSize = { width: '32', height: '32' }

export const STEP = {
  AUTH: 'auth',
  CODE: 'code',
  PASSWORD: 'password',
  SUCCESS: 'success',
}

export const MODE = {
  SIGNUP: 'signup',
  LOGIN: 'login',
}

// Open-on event published by the header Log in / Sign up buttons (UnifiedNavigation)
// while on /ai. ThreeDStudio subscribes to it (see useAuthModalTrigger).
export const AUTH_MODAL_EVENT = 'app:ai-sign-in:open'

export const OAUTH_PATHS = {
  google: '/users/auth/google_oauth2',
  facebook: '/users/auth/facebook',
}

export const CODE_LENGTH = 6
